import React, { useEffect, useState } from "react";
import "./App.css";
import Piano from "./Piano";
function App() {
  return (
    <div className="app-container">
      <Piano />
    </div>
  );
}

export default App;
